import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Lock from '../../Images/Lock.svg';
import CameraLogo from '../../Images/Camera.svg';
import LogoutModal from '../../Components/LogoutModal';
import classes from '../../style/Style.module.css';
import { useSelector } from 'react-redux';
import { selectIINNumber } from '../../Store/IINSlice';
import { ROUTE_Bank_Proof_Submitted, ROUTE_UPDATED_PORT_FOLIO_SCREEN,ROUTE_CUSTOMER_SUPPORT_SCREEN } from '../../Routes';
import DextersScanning from '../ScanningLotties/DextersScanning';

const CancelledCheque = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [base64Content, setBase64Content] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [proceedClicked, setProceedClicked] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { bankAccountNumber, bankIfscCode, IIN } = location.state || {};
    const { CollectBankData } = location.state || {};
    const iinNumber = useSelector(selectIINNumber);

    console.log(bankAccountNumber, bankIfscCode, IIN, CollectBankData, iinNumber, "this data is parsing")
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileName = file.name;
            const fileSize = file.size;

            // Validate file type
            const validExtensions = ['.tiff', '.tif', ' .TIF', '.TIFF'];
            const fileExtension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                toast.error('Please upload TIFF file.');
                return;
            }

            // Validate file size (5 MB = 5 * 1024 * 1024 bytes)
            if (fileSize >= 5 * 1024 * 1024) {
                toast.error('Max. File Size Allowed is 5 MB.');
                return;
            }

            // Read and encode file to base64
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                setBase64Content(base64String);
                setSelectedFile(file);
                setFileUrl(URL.createObjectURL(file));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async () => {
        if (!selectedFile) {
            toast.error('Please upload a TIFF file.');
            return;
        }


        if (!iinNumber || !bankAccountNumber || !bankIfscCode) {
            toast.error('Missing required information.');
            return;
        }

        const requestBody = {
            bankProofUpload: {
                iin: iinNumber || IIN,
                bankAccountNumber: bankAccountNumber || CollectBankData.bankAccountNumber,
                bankIfscCode: bankIfscCode || CollectBankData.bankIfscCode,
                base64Content: base64Content
            }
        };

        try {
            const response = await axios.post(
                'https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc',
                requestBody,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            const { status, message, errorMessage, body } = response.data;

            if (status === true && message === 'Success' && body) {
                const nextRequestBody = {
                    bankProofSendNse: {
                        iin: iinNumber || IIN,
                        doc: body
                    }
                };

                const nextResponse = await axios.post(
                    'https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc',
                    nextRequestBody,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                const nextResponseData = nextResponse.data;

                if (nextResponseData.status === true && nextResponseData.message === 'Success' && nextResponseData.body) {
                    toast.success('Bank proof submitted successfully.');
                    navigate(ROUTE_Bank_Proof_Submitted);
                } else {
                    toast.error(nextResponseData.errorMessage || 'Error in submitting bank proof.');
                }
            } else {
                toast.error(errorMessage || 'Error in uploading bank proof.');
            }
        } catch (error) {
            toast.error('An error occurred while processing your request.');
        }
    };

    const handleClear = () => {
        setSelectedFile(null);
        setFileUrl(null);
        setBase64Content('');
        toast.error('Image upload canceled');
    };

    const handleBack = () => {
        setShowModal(true);
    };

    const handleLogoutConfirm = () => {
        navigate(DextersScanning);
    };

    return (
        <div className="CancelledCheque_Main_Container">
            <div className="CancelledCheque_Header_Container">
                <p className="Header_Arrow">
                    <ArrowBackIosIcon className="Back_btn" onClick={handleBack} />
                </p>
            </div>
            <div className="CapturePhoto_Container">
                <p className="CapturePhoto_Heading_text">Upload Bank Proof</p>
                <span className="Input_Sub_heading5">
                    Help us verify your bank details by uploading an image of your bank proof.
                </span>
                <span className="Input_Sub_heading5">
                    Supported Bank Proofs: Bank Statement, Cancelled Cheque, Passbook.<br /><br/>
                    Supported File Extensions: .tiff <br />
                    Max. File Size: 5 MB.<br />
                </span>
                <span className="Input_Sub_heading5">
                Bank Account Number : {bankAccountNumber} <br/>
                Bank IFSC Code : {bankIfscCode}
                </span>
                 

                <div className="Warnings_Small_Conatiner">
                    <div className="Regulatory_Requirement_Container">
                        <img alt="Lock-img" src={Lock} />
                        <span className="Regulatory_Requirement_Text">
                            Regulatory requirement
                        </span>
                    </div>
                    <p className={classes.ErrorMessage}>
                        {proceedClicked && !selectedFile && 'Please upload a TIFF file.'}
                    </p>
                </div>
                <div className={`${"Camera_Container"} ${selectedFile ? "Camera_Container_Selected" : ''}`}>
                    <input
                        type="file"
                        accept=".tif,.tiff"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="imageUpload"
                    />
                    <label htmlFor="imageUpload">
                        {selectedFile ? (
                            <img alt="TIFF/TIF Preview" src={fileUrl} className={classes.TiffPreview} />
                        ) : (
                            <img alt="Camera" src={CameraLogo} className={classes.CameraLogo} />
                        )}
                    </label>
                </div>
                <div className="Kyc_Btns_Container">
                    <button
                        className="Kyc_Clear_Btn"
                        onClick={handleClear}
                    >
                        Clear
                    </button>
                    <button
                        className="Kyc_Proceed_Btn"
                        onClick={handleSubmit}
                    >
                        Proceed
                    </button>
                </div>
                <div className={classes.Null_Message_Container}>
                    <button
                        className={classes.Submit_button}
                        onClick={() => navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN)}
                    >
                        Contact Dexterr Support Team
                    </button>
                </div>
            </div>
            <ToastContainer />
            <LogoutModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onConfirm={handleLogoutConfirm}
            />
        </div>
    );
};

export default CancelledCheque;
